import { render, staticRenderFns } from "./MiscellaneousField.vue?vue&type=template&id=ef192716&"
import script from "./MiscellaneousField.vue?vue&type=script&lang=js&"
export * from "./MiscellaneousField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef192716')) {
      api.createRecord('ef192716', component.options)
    } else {
      api.reload('ef192716', component.options)
    }
    module.hot.accept("./MiscellaneousField.vue?vue&type=template&id=ef192716&", function () {
      api.rerender('ef192716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/SettingsDivisionMiscellaneous/Components/MiscellaneousField.vue"
export default component.exports